"use client";

import classNames from "classnames";

import { StepIndicator, StepIndicatorState } from "./StepIndicator";

import { StepperProps } from "./types";

import "./styles.scss";

const getStepState = (
  index: number,
  currentStep: number,
  completedSteps: boolean[]
): StepIndicatorState => {
  if (completedSteps[index]) return "completed";
  if (index === currentStep) return "active";
  return "pending";
};

export const Stepper = ({
  stepButtons,
  completedSteps = [],
  currentStep = 0,
  isStepEnabled,
  onStepClick,
  variant = "labeled",
}: StepperProps) => {
  const isCompact = variant === "compact";

  const getStepLabelClassName = (index: number) => {
    const state = getStepState(index, currentStep, completedSteps);

    return classNames("Stepper__label", {
      "Stepper__label--active": state === "active",
      "Stepper__label--completed": state === "completed",
      "Stepper__label--pending": state === "pending",
    });
  };

  const getStepButtonClassName = (index: number) => {
    const enabled = isStepEnabled ? isStepEnabled(index) : true;

    return classNames("Stepper__step", {
      "Stepper__step--disabled": !enabled,
    });
  };

  return (
    <div
      data-testid="Stepper"
      className={classNames("Stepper", {
        "Stepper--compact": isCompact,
        "Stepper--labeled": !isCompact,
      })}
    >
      <div
        className="Stepper__steps"
        data-testid="Stepper__steps"
      >
        {stepButtons.map((step, index) => {
          const enabled = isStepEnabled ? isStepEnabled(index) : true;
          const state = getStepState(index, currentStep, completedSteps);

          return (
            <div
              className="Stepper__step-group"
              key={`step-${index}`}
            >
              <button
                type="button"
                data-qa={step.dataQA}
                data-testid={`Stepper__step-${index}`}
                className={getStepButtonClassName(index)}
                disabled={!enabled}
                aria-label={step.label}
                onClick={() => onStepClick?.(index)}
              >
                <StepIndicator
                  stepNumber={index + 1}
                  state={state}
                />
                {!isCompact && <span className={getStepLabelClassName(index)}>{step.label}</span>}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
